import { AttributesMixin, define, Model, type } from "@type-r/models";
import { matchString } from "api/common";
import { asTimelessDate } from "lqx-react";
import { AssetChange } from "./assetChange";
import { AssetType } from "./assetType";
import { restfulIO } from "./endpoint";
import { CreditorBankAccount, DebtorBankAccount, Payment } from "./payment";

export interface PaymentChange extends AttributesMixin<typeof PaymentChange> { }
@define
export class PaymentChange extends AssetChange {
    static endpoint = restfulIO('api/v1/ingest/payments/assets');

    static attributes = {
        ...AssetChange.attributes,
        updateAsset: Payment,
        assetType: type(Number).value(AssetType.payment),
    };

    getAssetType() {
        return AssetType.payment;
    }

    getAssetName() {
        return 'Payment';
    }

    get debtorBankAccount(): DebtorBankAccount {
        return this.getValue("debtorBankAccount") || new DebtorBankAccount();
    }

    get creditorBankAccount(): CreditorBankAccount {
        return this.getValue("creditorBankAccount") || new CreditorBankAccount();
    }

    get referenceNumber(): String {
        return this.getValue("referenceNumber");
    }

    get assetPaymentDate(): Date {
        const value = this.getValue("assetPaymentDate");
        return value ? new Date(value) : null;
    }

    get paymentAmount(): Number {
        return this.getValue("paymentAmount");
    }

    get currency(): String {
        return this.getValue("currency");
    }

    get postedOn(): Date {
        const value = this.getValue("postedOn");
        return value ? new Date(value) : null;
    }

    filter(filter) {
        return (matchString(this.referenceNumber.toString(), filter.search) ||
            matchString(this.debtorBankAccount.payor.name, filter.search) ||
            matchString(this.creditorBankAccount.payee.name, filter.search) ||
            matchString(this.paymentAmount.toString(), filter.search) ||
            matchString(asTimelessDate(this.postedOn), filter.search) ||
            matchString(this.state.name, filter.search)) &&
            this.hasReceivedAssetEventsFor(filter.eventType);
    }
}

export interface PaymentData extends AttributesMixin<typeof PaymentData> { }
@define
export class PaymentData extends Model {
    static endpoint = restfulIO('api/v1/ingest/payments/assets');

    static attributes = {
        count: Number,
        items: [PaymentChange]
    };
}
